import { render, staticRenderFns } from "./my-detail.vue?vue&type=template&id=8945ffa6&scoped=true&"
import script from "./my-detail.vue?vue&type=script&lang=js&"
export * from "./my-detail.vue?vue&type=script&lang=js&"
import style0 from "./my-detail.vue?vue&type=style&index=0&id=8945ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945ffa6",
  null
  
)

export default component.exports